import { render } from "./TradeInForm.vue?vue&type=template&id=5d286526"
import script from "./TradeInForm.vue?vue&type=script&lang=js"
export * from "./TradeInForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__